import Choices from "choices.js";

export default async function initSelectors() {

    await new Promise((resolve) => {
        this.countryRef = new Choices(this.$refs.countryRef, {
            searchEnabled: false,
            searchChoices: false,
            shouldSort: false,
            itemSelectText: "",
            allowHTML: true,
        });

        resolve();

    })

    await new Promise((resolve) => {
        this.productRef = new Choices(this.$refs.productRef, {
            searchEnabled: false,
            searchChoices: false,
            shouldSort: false,
            itemSelectText: "",
            allowHTML: true,
        });
        resolve();
    })

    await new Promise((resolve) => {
        this.subProductRef = new Choices(this.$refs.subProductRef, {
            searchEnabled: false,
            searchChoices: false,
            shouldSort: false,
            itemSelectText: "",
            allowHTML: true,
        });
        resolve();
    })

}
